import { useSelector } from 'react-redux';
import { get } from 'global/lib/lodash';
import { useEffect, useState } from 'react';
import arrayToTree from 'array-to-tree';

export const useUser = (props) => {
  const me = useSelector((state) => get(state, 'auth.user'));
  const realm = useSelector((state) => get(state, 'auth.realm'));
  const realms = useSelector((state) => get(state, 'auth.user.realms'));
  
  const [state, setState] = useState({
    parentRealm: {},
  })

  const realmOrUserRealm = realm || get(me, 'realm', {});

  useEffect(() => {
    if (!Array.isArray(realms)) { return }

    const list = arrayToTree([me.realm, ...realms], { parentProperty: 'parentId' });

    const pr = get(list, '0.children.0', realmOrUserRealm);

    setState(s => ({ ...s, parentRealm: pr }))
  }, [realms]);

  return {
    me,
    realm: realm,
    userRealm: get(me, 'realm', {}),
    realmOrUserRealm,
    ...state,
    highestRealm: realm || state.parentRealm,
  };
};
